export interface Product {
  id: string;
  name: string;
  category: string;
  series: string;
  price: string;
  image: string;
  detailImages?: string[];
  description: string;
  specs: {
    length: string;
    weight: string;
    material: string;
    buoyancy: string;
  };
  features: string[];
  scenarios: string[];
}

export const productCategories = [
  { id: 'all', name: '全部产品' },
  { id: 'gh2', name: 'GH二代系列' },
  { id: 'gl', name: '攻鲢手系列' },
  { id: 'lb', name: 'LB系列' },
  { id: 'nano', name: '纳米系列' },
  { id: 'reed', name: '芦苇系列' }
];

export const products: Product[] = [
  // GH二代系列（纳米-日夜两用）
  {
    id: 'gh2-001',
    name: 'GH二代·日夜两用',
    category: 'gh2',
    series: 'GH二代系列',
    price: '¥45-59.9',
    image: '/images/products/gh2/gh2-z1.jpg?v=1',
    detailImages: ['/images/products/gh2/gh-new.jpg?v=1', '/images/products/gh2/gh2-02.png?v=1'],
    description: '野钓黑坑鲫鲤设计的一款浮漂，双面OLED光源，0.7mm倒锥细尾',
    specs: {
      length: '28-52cm',
      weight: '1.2-3.2g',
      material: '纳米材质',
      buoyancy: '高灵敏'
    },
    features: ['双面OLED光源', '0.7mm倒锥细尾', '日夜两用'],
    scenarios: ['野钓', '黑坑鲫鲤', '浅水钓', '深水钓']
  },

  // 攻鲢手系列
  {
    id: 'gl-001',
    name: '攻鲢手·白天漂',
    category: 'gl',
    series: '攻鲢手系列',
    price: '¥39',
    image: '/images/products/gls/gls-b-z.jpg',
	detailImages: ['/images/products/gls/gls-bai1.png', '/images/products/gls/gls-bai2.png', '/images/products/gls/gls-bai3.png', '/images/products/gls/gls-bai4.png'],
    description: '黑坑鲢鳙设计的一款浮漂，特别对回锅鱼开发，专门解决回锅鱼警惕性高、出口轻难中鱼的问题。',
    specs: {
      length: '35-45cm',
      weight: '2.0-4.0g',
      material: '纳米材质',
      buoyancy: '高浮力'
    },
    features: ['回锅鱼专用', '空心玻纤材质', '轻浮力大', '信号清晰'],
    scenarios: ['黑坑鲢鳙', '回锅鱼', '白天钓']
  },
  {
    id: 'gl-002',
    name: '攻鲢手·LED灯排尾',
    category: 'gl',
    series: '攻鲢手系列',
    price: '¥55-69',
    image: '/images/products/gls/gls-led-z.jpg',
	detailImages: ['/images/products/gls/gls-led1.png', '/images/products/gls/gls-led2.png', '/images/products/gls/gls-led2.png'],
    description: '黑坑鲢鳙设计的LED灯排尾浮漂，升级发光方式，改用LED双排灯带。',
    specs: {
      length: '36.4-62cm',
      weight: '3.5-7g',
      material: '纳米材质',
      buoyancy: '高浮力'
    },
    features: ['LED双排灯带', '浅水专用'],
    scenarios: ['浅水鲢鳙', '水皮钓', '夜钓']
  },
   {
    id: 'gl-003',
    name: '攻鲢手·回锅款·非LED尾',
    category: 'gl',
    series: '攻鲢手系列',
    price: '¥59',
    image: '/images/products/gls/gls-hg-z.jpg',
	detailImages: ['/images/products/gls/gls-huiguo.png'],
    description: '采用灯珠+光纤柔目发光技术，全目3.1mm加粗，载饵能力强。',
    specs: {
      length: '64-76cm',
      weight: '6.0-8.0g',
      material: '纳米材质',
      buoyancy: '高浮力'
    },
    features: ['柔目发光', '数控芯片', '3.0mm加粗', 'CR425电池'],
    scenarios: ['回锅鲢鳙', '黑坑', '夜钓']
  },
  {
    id: 'gl-004',
    name: '攻鲢手·定层款·非LED尾',
    category: 'gl',
    series: '攻鲢手系列',
    price: '¥59',
    image: '/images/products/gls/gls-dc-z.jpg',
	detailImages: ['/images/products/gls/gls-dc.png'],
    description: '采用灯珠+光纤柔目发光技术，中间三目加粗3.6mm，载饵能力强。',
    specs: {
      length: '60-65cm',
      weight: '3.5-7.0g',
      material: '纳米材质',
      buoyancy: '超高灵敏'
    },
    features: ['柔目发光', '数控芯片', '3.6mm加粗', 'CR425电池'],
    scenarios: ['回锅鲢鳙', '黑坑', '夜钓']
  },
  {
    id: 'gl-005',
    name: '攻鲢手·回锅款·白天漂',
    category: 'gl',
    series: '攻鲢手系列',
    price: '¥45',
    image: '/images/products/gls/gls-b-z.jpg',
	detailImages: ['/images/products/gls/gls-hg-b.png'],
    description: '全目3.1mm加粗，载饵能力强。',
    specs: {
      length: '60-65cm',
      weight: '3.5-7.0g',
      material: '纳米材质',
      buoyancy: '超高灵敏'
    },
    features: ['3.1mm加粗','空心玻纤材质', '轻浮力大', '信号清晰'],
    scenarios: ['回锅鲢鳙', '黑坑', '夜钓']
  },
  // LB系列（芦苇-白天漂）
  {
    id: 'lb-001',
    name: 'LB系列·白天漂',
    category: 'lb',
    series: 'LB系列',
    price: '¥39',
    image: '/images/products/lb/lb-z.jpg',
	detailImages: ['/images/products/lb/01.png', '/images/products/lb/02.png', '/images/products/lb/03.png', '/images/products/lb/04.png', '/images/products/lb/05.png', '/images/products/lb/06.png', '/images/products/lb/07.png', '/images/products/lb/08.png'],
    description: '野钓大综合设计的一款浮漂，包含野钓中常见鱼种，高透硬尾更透亮，特殊工艺烘干，自重更轻。',
    specs: {
      length: '32-42cm',
      weight: '1.5-2.5g',
      material: '陈年芦苇',
      buoyancy: '高灵敏'
    },
    features: ['高透硬尾', '特殊烘干工艺', '高倍比吃铅', '爆顶加固'],
    scenarios: ['野钓大综合', '多种鱼种', '白天钓']
  },
    {
    id: 'lb-002',
    name: 'LB系列·哪吒直击天命',
    category: 'lb',
    series: 'LB系列',
    price: '¥42.8',
    image: '/images/products/lb/zjtm-z.jpg',
	detailImages: ['/images/products/lb/zjtm.jpg?v=1'],
    description: '哪吒主题限量款浮漂，采用高透硬尾设计，特殊工艺处理，外观独特个性。',
    specs: {
      length: '42-46cm',
      weight: '1.5-2.3g',
      material: '陈年芦苇',
      buoyancy: '高灵敏'
    },
    features: ['哪吒主题', '高透硬尾', '特殊工艺', '个性外观'],
    scenarios: ['野钓', '收藏', '白天钓']
  },
   {
    id: 'lb-003',
    name: 'LB系列·哪吒',
    category: 'lb',
    series: 'LB系列',
    price: '¥42.8',
    image: '/images/products/lb/be-ez01.jpg',
	detailImages: ['/images/products/lb/lbe-ez01.jpg'],
    description: '哪吒主题限量款浮漂，采用高透硬尾设计，特殊工艺处理，外观独特个性。',
    specs: {
      length: '45-46cm',
      weight: '1.5-2.3g',
      material: '陈年芦苇',
      buoyancy: '高灵敏'
    },
    features: ['哪吒主题', '高透硬尾', '特殊工艺', '个性外观'],
    scenarios: ['野钓', '收藏', '白天钓']
  },

  // 纳米系列
  {
    id: 'nano-001',
    name: '一心纳米·白天漂',
    category: 'nano',
    series: '纳米系列',
    price: '¥90',
    image: '/images/products/yxnm/yxnm-z.jpg',
	detailImages: ['/images/products/yxnm/yxnm01.png?v=1','/images/products/yxnm/yxnm02.png?v=1','/images/products/yxnm/yxnm03.png?v=1','/images/products/yxnm/yxnm04.png?v=1','/images/products/yxnm/yxnm05.png?v=1','/images/products/yxnm/yxnm06.png?v=1','/images/products/yxnm/yxnm07.png?v=1','/images/products/yxnm/yxnm08.png?v=1','/images/products/yxnm/yxnm09.png?v=1'],
    description: '严苛质检流程，八道质检严格控制自重，自重和吃铅误差0.02g以内，定制荧光漆放大三倍效果。',
    specs: {
      length: '30-45cm',
      weight: '1.0-2.5g',
      material: '纳米材质',
      buoyancy: '高灵敏'
    },
    features: ['八道质检', '误差0.02g以内', '3.4倍吃铅比', '软身漆防爆'],
    scenarios: ['竞技钓', '黑坑', '白天钓']
  },
  {
    id: 'nano-002',
    name: '壹号漂·综合款',
    category: 'nano',
    series: '纳米系列',
    price: '¥25',
    image: '/images/products/1hao/1hao-z.jpg',
	detailImages: ['/images/products/1hao/01.png','/images/products/1hao/02.png','/images/products/1hao/03.png','/images/products/1hao/04.png','/images/products/1hao/01x.png','/images/products/1hao/02x.png'],
    description: '不同漂型漂尾细节单独设计，保证不同杆长醒目又灵敏，漂身标注吃铅、建议鱼种、建议杆长。',
    specs: {
      length: '28-42cm',
      weight: '0.8-2.5g',
      material: '纳米材质',
      buoyancy: '高灵敏'
    },
    features: ['漂尾单独设计', '标注详细', '一体通纤', '防止爆顶'],
    scenarios: ['新手钓', '综合钓', '白天钓']
  },
    {
    id: 'nano-004',
    name: 'CD系列·CD01/CD02/CD03',
    category: 'nano',
    series: '纳米系列',
    price: '¥29-35',
    image: '/images/products/cd/cd-z.jpg',
	detailImages: ['/images/products/cd/cd01.png','/images/products/cd/cd02.png','/images/products/cd/cd03.png'],
    description: 'CD系列纳米白天漂，专业设计，性价比高，适合多种垂钓场景。',
    specs: {
      length: '32-40cm',
      weight: '1.0-2.0g',
      material: '纳米材质',
      buoyancy: '高灵敏'
    },
    features: ['专业设计', '性价比高', '多场景适用', '品质保证'],
    scenarios: ['休闲钓', '黑坑', '白天钓']
  },
  {
    id: 'nano-006',
    name: '攻滑鲢·LED灯排尾',
    category: 'nano',
    series: '纳米系列',
    price: '¥98',
    image: '/images/products/ghl/ghl-z.jpg',
	detailImages: ['/images/products/ghl/ghl01.png','/images/products/ghl/ghl02.png'],
    description: '漂尾加粗采用1.3-1.9mm顶部加粗和1.3-1.9-1.3mm中部加粗方式，小尾径加自重轻出口会更好，同时对于用户自身控饵的能力会较高；',
    specs: {
      length: '35-45cm',
      weight: '1.2-2.5g',
      material: '纳米材质',
      buoyancy: '高灵敏'
    },
    features: ['精细工艺', '性能稳定'],
    scenarios: ['黑坑', '竞技钓']
  },
 {
    id: 'nano-007',
    name: 'HK三代-青云直上·LED灯排尾',
    category: 'nano',
    series: '纳米系列',
    price: '¥69-79',
    image: '/images/products/hk3/hk3-z.jpg',
	detailImages: ['/images/products/hk3/hk3.png'],
    description: '倒锥细尾径，切水快，翻身迅速，腰力更强，不易断尾，顿口明显；',
    specs: {
      length: '60cm',
      weight: '1.5-3.1g',
      material: '纳米材质',
      buoyancy: '高灵敏'
    },
    features: ['精细工艺', '性能稳定'],
    scenarios: ['黑坑', '竞技钓']
  },
   {
    id: 'nano-008',
    name: '慢诱·LED灯排尾',
    category: 'nano',
    series: '纳米系列',
    price: '¥49-90',
    image: '/images/products/my/my-z.jpg',
	detailImages: ['/images/products/my/my01.jpg?v=1'],
    description: '夜光尾采用LED双排灯珠尾，白天款采用扁尾设计,日夜两用双尾无缝替换；',
    specs: {
      length: '80cm',
      weight: '5.0-12g',
      material: '纳米材质',
      buoyancy: '高灵敏'
    },
    features: ['精细工艺', '性能稳定'],
    scenarios: ['黑坑', '竞技钓']
  },
     {
    id: 'nano-009',
    name: 'JT双浮·白天漂',
    category: 'nano',
    series: '纳米系列',
    price: '¥35',
    image: '/images/products/jt/jt-z.jpg',
	detailImages: ['/images/products/jt/jt01.jpg?v=1'],
    description: '【双浮】鲢鱅浮漂，漂尾颜色醒目，飘相信号准确，托饵时容错空间；',
    specs: {
      length: '36-61cm',
      weight: '4.0-8.5g',
      material: '纳米材质',
      buoyancy: '高灵敏'
    },
    features: ['精细工艺', '性能稳定'],
    scenarios: ['黑坑', '竞技钓']
  },
  
  // 芦苇系列（白天漂）
  {
    id: 'reed-001',
    name: '一心芦苇·白天漂',
    category: 'reed',
    series: '芦苇系列',
    price: '¥100',
    image: '/images/products/yxlw/yxlw-z.jpg',
	detailImages: ['/images/products/yxlw/yxlw01.png','/images/products/yxlw/yxlw02.png','/images/products/yxlw/yxlw03.png'],
    description: '定制荧光漆透光性强长时间不掉漆，一体通纤防爆顶加固，S级陈年芦苇纯手工打磨。',
    specs: {
      length: '32-45cm',
      weight: '1.2-2.8g',
      material: '陈年芦苇',
      buoyancy: '超高灵敏'
    },
    features: ['定制荧光漆', '一体通纤', 'S级芦苇', '手工打磨'],
    scenarios: ['黑坑', '竞技钓', '白天钓']
  },
    {
    id: 'reed-002',
    name: 'LS芦苇·白天漂',
    category: 'reed',
    series: '芦苇系列',
    price: '¥98',
    image: '/images/products/ls/ls-z.jpg',
	detailImages: ['/images/products/ls/ls01.png'],
    description: '匠人纯手工打磨成型，严格八道质检，四遍上漆，四遍打磨，不增加自重，防水更好，品质保证。',
    specs: {
      length: '30-40cm',
      weight: '1.0-2.0g',
      material: '陈年芦苇',
      buoyancy: '高灵敏'
    },
    features: ['1.5倍吃铅比', '自重轻', '八道质检', '四遍上漆'],
    scenarios: ['轻口鱼', '竞技钓', '白天钓']
  },
  {
    id: 'reed-003',
    name: '攻鲫·芦苇·白天漂',
    category: 'reed',
    series: '芦苇系列',
    price: '¥130',
    image: '/images/products/gj/gj-z.jpg?v=1',
	detailImages: ['/images/products/gj/gj01.jpg?v=1'],
    description: '严苛质检八道流程，自重和吃铅误差不超过0.1g，专供油墨放大效果出色，超1.5倍吃铅比。',
    specs: {
      length: '28-38cm',
      weight: '0.8-1.8g',
      material: '陈年芦苇',
      buoyancy: '超高灵敏'
    },
    features: ['误差0.1g以内', '专供油墨', '超1.5倍吃铅', '信号稳定'],
    scenarios: ['鲫鱼钓', '轻口鱼', '白天钓']
  }
];
